import { render } from "./MiezzButtonDropdown.vue?vue&type=template&id=f3189b06&scoped=true&ts=true"
import script from "./MiezzButtonDropdown.vue?vue&type=script&lang=ts"
export * from "./MiezzButtonDropdown.vue?vue&type=script&lang=ts"

import "./MiezzButtonDropdown.vue?vue&type=style&index=0&id=f3189b06&lang=sass&scoped=true"
import "./MiezzButtonDropdown.vue?vue&type=style&index=1&id=f3189b06&lang=css"
import "./MiezzButtonDropdown.vue?vue&type=style&index=2&id=f3189b06&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3189b06"]])

export default __exports__